import type { MoneyValue } from "../../../shared/money/Money";
import type { PostalAddress } from "../lib/gboModels";
import { gboApi } from "./gboApiBase";

export type PortalInvoice = {
  reference: string;
  number: string;
  issuedOn: string;
  dueOn: string;
  total: MoneyValue;
  paid: MoneyValue;
  creditApplied: MoneyValue;
  balance: MoneyValue;
};
export type PortalPayment = {
  id: string;
  effectiveAt: string;
  totalReceived: MoneyValue;
  surcharge: MoneyValue;
  refundedAmount: MoneyValue;
  method: "card" | "bank" | "cash" | "check";
  card: { brand: string; last4: string } | null;
};
export type PortalOverview = {
  customer: { id: string; accountCode: string; name: string; billingAddress: PostalAddress };
  accountBalance: MoneyValue;
  earliestOpenInvoiceDueDate: string | null;
  openInvoices: { count: number; balance: MoneyValue; items: PortalInvoice[] };
  recentPayments: PortalPayment[];
};

export const portalOverviewApi = gboApi.injectEndpoints({
  endpoints: (builder) => ({
    getPortalOverview: builder.query<PortalOverview, string>({
      query: () => ({ url: "portal/overview" }),
      keepUnusedDataFor: 0,
    }),
  }),
});
export const { useGetPortalOverviewQuery } = portalOverviewApi;
